export const data = {
	data() {
		return {
			headerList: [
				// {
				// 	prop: 'id',
				// 	label: '序号',
				// 	width: 80
				// },
				// {
				// 	prop: 'sort',
				// 	label: '排序'
				// },
				// {
				// 	prop: 'title',
				// 	label: '图文名称'
				// },
				// {
				// 	prop: 'price',
				// 	label: '价格'
				// },
				{
					prop: 'columnObj',
					label: '课程',
					width: 370
				},
				{
					prop: 'verify_counts',
					label: '全部/已上架/草稿',
					width: 140
					
				},
				{
					prop: 'buy',
					label: '浏览/购买/评价',
					width: 120
				},
				{
					prop: 'my_h5BuyLink',
					label: 'H5购课链接',
					width: 100
				},
				// {
				// 	prop: 'status',
				// 	label: '状态'
				// },
				// {
				// 	prop: 'reason',
				// 	label: '驳回原因/下架原因'
				// },
				// {
				// 	prop: 'created_time',
				// 	label: '创建时间'
				// }
			]
		}
	}
}